import React, { Component } from 'react';
import { message, Form, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedFooter from '../connectedComponents/ConnectedFooter.js';
import { apis } from '../api/index.js';
import './register.css';
import email from '../imgs/email.png';
import { LoginPassIcon, LoginEamilIcon } from '../../src/utils/svg';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class RegisterForm extends Component {
  static propTypes = {
    form: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      tips: '',
      confirmDirty: false,
      jobList: [],
      regSuccess: false,
      email: '',
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
  };

  componentDidMount() {
    this.props.form.validateFields();
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password'))
      callback('两次密码不一致');
    else callback();
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty)
      form.validateFields(['confirm'], { force: true });

    callback();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) this.register(values);
    });
  };

  register = values => {
    const post = {
      nickName: values.email,
      password: values.password,
      mobile: '13800000000',
      email: values.email,
      jobId: values.job,
    };
    apis.register(post).then(result => {
      if (result.code !== '0') {
        message.error(result.message);
      } else {
        message.success('注册成功，去邮箱激活后即可正常使用');
        this.setState({ regSuccess: true, email: values.email });
      }
    });
  };

  handleLogin = () => {
    this.props.history.push('/login');
  };

  hideEmail = () => {
    const { email } = this.state;
    const lenght = email.lenght;
    return email.substr(0, 3) + '****' + email.substr(7, lenght);
  };

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { isFieldTouched, getFieldError } = this.props.form;
    const { regSuccess } = this.state;
    const emailError = isFieldTouched('email') && getFieldError('email');
    const passError = isFieldTouched('password') && getFieldError('password');
    const rpError = isFieldTouched('rePassword') && getFieldError('rePassword');
    return (
      <div className="reg-page-bg">
        <ConnectedHeader login={true} home={true} user={this.props.user} />
        <div className="register-box">
          <div className="center-form">
            {regSuccess ? (
              <div className="reg-success">
                <p>
                  <img src={email} alt="" />
                </p>
                <p className="reg-suc-text1">请登录邮箱验证</p>
                <p className="reg-suc-text2">
                  账号激活链接已发送至您的邮箱：
                  <span>{this.hideEmail()}</span>
                </p>
                <p className="reg-suc-text3">
                  请您登录邮箱，按邮件中的提示完成账号激活操作
                </p>
              </div>
            ) : (
              <>
                <p className="form-tit">注册信息</p>
                <Form onSubmit={this.handleSubmit} className="login-form">
                  <Form.Item
                    validateStatus={emailError ? 'error' : ''}
                    help={emailError || ''}
                  >
                    {getFieldDecorator('email', {
                      rules: [
                        { required: true, message: '请输入邮箱' },
                        { type: 'email', message: '邮箱格式不正确' },
                      ],
                    })(
                      <div className="loginIconBox">
                        <span className="loginIcon">
                          <LoginEamilIcon />
                        </span>
                        <Input placeholder="邮箱" size="large" />
                      </div>
                    )}
                  </Form.Item>
                  <Form.Item
                    validateStatus={passError ? 'error' : ''}
                    help={passError || ''}
                  >
                    {getFieldDecorator('password', {
                      rules: [
                        { required: true, message: '请输入密码' },
                        { validator: this.validateToNextPassword },
                      ],
                    })(
                      <div className="loginIconBox">
                        <span className="loginIcon">
                          <LoginPassIcon />
                        </span>
                        <Input.Password placeholder="密码" size="large" />
                      </div>
                    )}
                  </Form.Item>
                  <Form.Item
                    validateStatus={rpError ? 'error' : ''}
                    help={rpError || ''}
                  >
                    {getFieldDecorator('rePassword', {
                      rules: [
                        { required: true, message: '请确认密码' },
                        { validator: this.compareToFirstPassword },
                      ],
                    })(
                      <div className="loginIconBox">
                        <span className="loginIcon">
                          <LoginPassIcon />
                        </span>
                        <Input.Password
                          placeholder="确认密码"
                          size="large"
                          onBlur={this.handleConfirmBlur}
                        />
                      </div>
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      size="large"
                      disabled={hasErrors(getFieldsError())}
                      block
                    >
                      注册
                    </Button>
                    <p className="to-register">
                      已有账号点击
                      <Button type="link" onClick={this.handleLogin}>
                        立即登录
                      </Button>
                    </p>
                  </Form.Item>
                </Form>
              </>
            )}
          </div>
        </div>
        <div className="reg-footer">
          <ConnectedFooter />
        </div>
      </div>
    );
  }
}

export default Form.create()(withRouter(RegisterForm));
